export default "/images/edit-3.svg?42fd3140828f74064ae7b15883577984";